import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/workspaces/edit'
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error'
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { fetchRequest as fetchWorkspaces } from '../../actions/workspaces/list';
import { fetchRequest as fetchUser } from '../../actions/user/getUser';

function* operation(action) {
  try {
    const { workspaceId, payload } = action;
    const response = yield call(axios.put, 
      `${config.API_URL}/workspace/${workspaceId}`,
      payload,
      { headers: getLocalUser() }
    );
    yield put(fetchSuccess(response.data));
    
    // Show success message
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Workspace updated successfully' });

    // Keep both workspace-list sources in sync: the on-demand
    // workspace_list slice AND the user payload that feeds
    // WorkspaceContext (header switcher, dashboard).
    yield put(fetchWorkspaces());
    yield put(fetchUser());
  } catch (error) {
    console.error('Edit workspace error:', error);
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
    
    // Handle specific error cases
    if (error?.response?.status === 403) {
      yield put({ type: 'SHOW_ERROR_SNACKBAR', message: 'You don\'t have permission to edit this workspace' });
    } else if (error?.response?.status === 404) {
      yield put({ type: 'SHOW_ERROR_SNACKBAR', message: 'Workspace not found' });
    } else {
      yield put({ type: 'SHOW_ERROR_SNACKBAR', message: 'Failed to update workspace' });
    }
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
